import React from 'react';
import ReactModal from 'react-modal';
import { PropTypes } from 'prop-types';

const modalStyles = {
  overlay: {
    zIndex: 50
  },
  content: {
    top:         '40%',
    left:        '50%',
    maxHeight:   '50%',
    right:       'auto',
    bottom:      'auto',
    marginRight: '-25%',
    transform:   'translate(-50%, -50%)',
    width:       '50%'
  }
};

class TDModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.isOpen
    };

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.notifyOfClose();
  }

  render() {
    return (
      <ReactModal
        ariaHideApp={false}
        style={modalStyles}
        isOpen={this.props.isOpen}
        onRequestClose={this.closeModal}
      >
        <div className="rc-modal-content">
          <div className="rc-modal-header">
            <h5>{this.props.title}</h5>
            <h5 className="close" onClick={this.closeModal}>&times;</h5>
          </div>
          <div className="rc-modal-body">
            {this.props.children}
          </div>
        </div>
      </ReactModal>
    );
  }
}

TDModal.propTypes = {
  isOpen:        PropTypes.bool,
  notifyOfClose: PropTypes.func,
  title:         PropTypes.string,
  children:      PropTypes.node.isRequired
};

export default TDModal;
